import Divider from '@zenbusiness/zui/Divider';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import useBreakpoints from '#client/hooks/useBreakpoints';

const TRANSACTION_ITEM_LOADING = 4;

export default function TransactionSkeleton() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <Stack
      aria-label="Loading transactions"
      spacing="8px"
    >
      <Skeleton />
      <Divider />
      {Array.from({ length: TRANSACTION_ITEM_LOADING }, (_, key) => (
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          key={key}
          py="15px"
        >
          <Stack
            alignItems="center"
            direction="row"
            spacing="16px"
          >
            <Skeleton
              height={40}
              width={40}
            />
            <Stack
              alignItems={isDesktop ? 'center' : 'flex-start'}
              direction={isDesktop ? 'row' : 'column'}
              spacing={isDesktop ? '16px' : '2px'}
            >
              <Skeleton
                height={isDesktop ? 34 : 26}
                width={isDesktop ? 90 : 110}
              />
              <Skeleton
                height={isDesktop ? 34 : 26}
                width={isDesktop ? 140 : 80}
              />
            </Stack>
          </Stack>
          <Skeleton
            height={isDesktop ? 34 : 26}
            width={isDesktop ? 140 : 99}
          />
        </Stack>
      ))}
    </Stack>
  );
}
